<template>
  <div class="bomItem__wrapper">
    <div class="bomItem__nameAndPrice">
      <div class="bomItem__nameAndDescription">
        <div class="bomItem__name">{{ partName }}</div>
        <div class="bomItem__description">{{ description }}</div>
      </div>
      <bomItemPrice :item="item" :deviceType="deviceType" />
    </div>
  </div>
</template>

<script>
import BomItemPrice from "./BomItemPrice";
import { mapGetters } from "vuex";
import { getCustomPositionDescription } from "../../../services/enhanced/PositionHelper";

export default {
  props: {
    item: Object,
    deviceType: {
      type: String,
      default: ""
    }
  },
  components: {
    BomItemPrice
  },
  computed: {
    ...mapGetters("enhancedproduct", ["getSelectedOptions", "getSections", "EnhancedSectionId"]),
    partName() {
      return this.item.PartName ? this.item.PartName : this.item.Value;
    },
    description() {
        let bayId = 0;
        if(this.getSelectedOptions[1].BayId !== undefined) {
        bayId =  this.getSelectedOptions[1].BayId.Value
       }
      let positionDescription =
        this.item.Position && this.item.Position.length > 0
          ? this.positionName(this.item.Position, bayId,  this.item.RulesKey )
          : "";
      let bomItemDescription = this.item.Text
        ? this.item.Text + positionDescription
        : "";
      return this.item.Text ? bomItemDescription : this.partName;
    }
  },
  methods: {
    positionName(pos, bayId, rulesKey) {
      return getCustomPositionDescription(pos, bayId, rulesKey);
    }
  }
};
</script>

<style lang="scss" scoped>
.bomItem {
  &__wrapper {
    border-bottom: 1px solid rgb(229, 229, 229);
    text-align: left;
    margin: 20px 0;
  }
  &__name {
    color: rgb(51, 51, 51);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.25px;
    line-height: 24px;
  }
  &__description {
    color: rgb(102, 103, 102);
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 21px;
    margin-bottom: 20px;
  }
  &__nameAndPrice {
    display: flex;
    align-items: start;
    justify-content: space-between;
    font-family: $font-family-sans-serif-regular;
  }
  &__nameAndDescription {
    max-width: 50%;
  }
}
</style>
